import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap/dist/js/bootstrap.bundle"

export default class extends Controller {
  connect() {
    new bootstrap.Modal(this.element, {
      backdrop: 'static',
      keyboard: false
    }).show()
  }
}
